// app/src/modules/ui/Layout.tsx — back-office application shell.
// The shared <AppHeader/> sits above a full-width content area so the whole app uses
// one chrome (matching the till). Deeper sections are reached from the Dashboard hub
// and the global bottom nav. The till ("/") and login render their own surfaces.
import { Suspense, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import AppHeader from "./AppHeader";
import { SectionTabs } from "./admin";
import { Loading } from "./Loader";
import { AppErrorBoundary } from "./SystemError";
import StatusBar from "./StatusBar";

export default function Layout() {
  const loc = useLocation();
  // Scroll to top on route change (the window scrolls, not a sidebar).
  useEffect(() => { window.scrollTo({ top: 0 }); }, [loc.pathname]);

  return (
    <div className="bo-shell">
      <AppHeader />
      <SectionTabs />
      <main className="bo-body">
        <div className="container-xl">
          {/* A second boundary INSIDE the shell. The outer one in App.tsx wraps
              <Routes>, so a single screen throwing took the header and the tabs
              with it and left the user stranded on an error page with nothing to
              click. Keyed on the path so navigating away clears the error rather
              than showing a stale crash for the next screen. */}
          <AppErrorBoundary key={loc.pathname}>
            <Suspense fallback={<Loading />}>
              <Outlet />
            </Suspense>
          </AppErrorBoundary>
        </div>
      </main>
      <StatusBar />
    </div>
  );
}
